import React from 'react';
import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { getFormFieldWrapperProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import { ValidatingFormComponent } from '@/formbuilder/formBuilder.constants';
import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import { DateTimeEntry } from '@/datetime/DateTimeEntry.atom';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { sqWorksheetStore } from '@/core/core.stores';
import moment from 'moment-timezone';

export interface DatePickerFormComponentProps extends ValidatingFormComponent<moment.Moment> {
  component: 'DatePickerFormComponent';
  id?: string;
  value: moment.Moment | undefined;
  placeholder?: string;
  labelIcon?: string;
  labelIconAction?: () => void;
  labelIconTooltip?: string;
  labelClassNames?: string;
  clearDate?: () => void;
}
export const DatePickerFormComponent: React.FunctionComponent<DatePickerFormComponentProps> = (props) => {
  const {
    name,
    extendValidation,
    validation,
    onChange,
    testId = 'formControl',
    required = false,
    customErrorText,
    labelIcon,
    labelIconAction,
    labelIconTooltip,
    labelClassNames,
    value,
  } = props;

  const timezone = useFluxPath(sqWorksheetStore, () => sqWorksheetStore.timezone);
  const defaultValidation = (value: moment.Moment | undefined) => !!required && !value;

  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);
  const formState = useForm().getState();
  const showError =
    _.has(formState.errors, name) &&
    formState.hasValidationErrors &&
    (formState.submitFailed || (formState.modified && formState.modified[name]));

  return (
    <FormFieldWrapper
      {...getFormFieldWrapperProps(props, ['id'])}
      testId={`${testId}-wrap`}
      labelIcon={labelIcon}
      labelIconAction={labelIconAction}
      labelIconTooltip={labelIconTooltip}
      labelClassNames={labelClassNames}
      showError={showError}
      customErrorText={customErrorText}>
      <Field name={name} validate={appliedValidation}>
        {({ input, meta }) => {
          const displayValue = input.value ? input.value : value;

          return (
            <DateTimeEntry
              testId={testId}
              datePickerExtraClassNames="width-100"
              extraClassName="ml5"
              date={value ? moment(value) : moment()}
              timezone={timezone}
              hideTimezone={true}
              dateFormat="l"
              inputHeight={35}
              updateDate={(date: moment.Moment | null) => {
                if (!date) return;
                input.onChange(date);
                onChange && onChange(date);
              }}
            />
          );
        }}
      </Field>
    </FormFieldWrapper>
  );
};
